import moment from 'moment';
import { openPrintPreview } from './printPreviewHelper';
import { getSuperGroupName } from '../utils/getSuperGroupName';

const defineCss = () => `
  body {
  font-family: Arial, sans-serif;
  margin: 20px;
  font-size: 12px;
}
  .header {
  text-align: center;
  margin-bottom: 20px;
  border-bottom: 2px solid #000;
  padding-bottom: 10px;
}
  .company-name {
  font-size: 18px;
  font-weight: bold;
  color: #2c5aa0;
}
  .report-title {
  font-size: 16px;
  font-weight: bold;
  margin: 5px 0;
}

  .date-info {
  font-size: 14px;
  margin: 5px 0;
}

  table {
  width: 100%;
  border-collapse: collapse;
  margin: 10px 0;
  font-size: 11px;
}

th, td {
  border: 1px solid #000;
  padding: 4px 6px;
  text-align: left;
}
  th {
  background-color: #f0f0f0;
  font-weight: bold;
  text-align: center;
}

  .category-section {
  margin: 15px 0;
  page-break-inside: avoid;
}

  .category-title {
  font-weight: bold;
  background-color: #e6f3ff;
  padding: 5px;
  margin: 5px 0;
  border: 1px solid #000;
}

  .summary-section {
  margin-top: 20px;
  border-top: 2px solid #000;
  padding-top: 10px;
}

  .total-row {
  font-weight: bold;
  background-color: #f5f5f5;
}
  .text-center { text-align: center; }

  .text-right { text-align: right; }

@media print {
  body { margin: 0; }
    .no-print { display: none; }
}

@page {
  margin: 12mm 10mm;
  size: A4;
}
`;

const generatePrintableContent = (superGroups, orders, reportTitle) => {
  const sgs = Array.isArray(superGroups) ? superGroups : [];
  const rows = Array.isArray(orders) ? orders : [];

  const printingTime = moment().format('hh:mm A');
  const collectionDate = rows.length > 0 && rows[0].createdAt ? moment(rows[0].createdAt).format('DD-MMMM-YYYY') : moment().format('DD-MMMM-YYYY');

  const totalsBySG = {};
  let overallTotal = 0;
  let overallLess = 0;
  let overallPaid = 0;
  let overallDue = 0;
  rows.forEach(order => {
    sgs.forEach(sg => {
      const val = order.tests && order.tests[sg] ? Number(order.tests[sg] || 0) : 0;
      totalsBySG[sg] = (totalsBySG[sg] || 0) + val;
      overallTotal += val;
    });
    overallLess += Number(order.realDiscountAmount || 0);
    overallPaid += Number(order.realPaidAmount || 0);
    overallDue += Number(order.realDueAmount || 0);
  });

  const headerCols = sgs.map(sg => `<th>${getSuperGroupName(sg)}</th>`).join('');

  const bodyRows = rows.map(order => {
    const date = order.createdAt ? new Date(order.createdAt).toLocaleDateString() : '';
    const remarks = order.paymentType || '';
    const orderId = order.testOrderID || '';
    let rowTotal = 0;
    const sgCols = sgs.map(sg => {
      const val = order.tests && order.tests[sg] ? Number(order.tests[sg] || 0) : 0;
      rowTotal += val;
      return `<td class="text-center">৳${val.toLocaleString()}</td>`;
    }).join('');

    const endDate = order.lastPaymentDate ? new Date(order.lastPaymentDate).toLocaleDateString() : '';
    const doctorName = order.doctor?.docName || '-';

    return `
      <tr>
        <td class="text-center">${date}</td>
        <td class="text-center">${orderId}</td>
        <td class="text-center">${doctorName}</td>
        <td class="text-center">${remarks}</td>
        ${sgCols}
        <td class="text-center"><strong>৳${rowTotal.toLocaleString()}</strong></td>
        <td class="text-center">৳${(order.realPaidAmount || 0).toLocaleString()}</td>
        <td class="text-center">৳${(order.realDueAmount || 0).toLocaleString()}</td>
        <td class="text-center">৳${(order.realDiscountAmount || 0).toLocaleString()}</td>
        <td class="text-center">${endDate}</td>
      </tr>
  `;
  }).join('');

  const totalsCols = sgs.map(sg => `<td class="text-center"><strong>৳${(totalsBySG[sg] || 0).toLocaleString()}</strong></td>`).join('');

  return `
    <div class="header">
      <div class="company-name">MEDIPLUS MEDICAL SERVICES (Pvt) LTD.</div>
      <div class="report-title">${reportTitle || 'Daily Collection'}</div>
      <div class="date-info">Collection Date: ${collectionDate} <br/> Printing Time: ${printingTime}</div>
    </div>

    <table>
      <thead>
        <tr>
          <th>Date</th>
          <th>Order ID</th>
          <th>Doctor Name</th>
          <th>Remarks</th>
          ${headerCols}
          <th>Total</th>
          <th>Advance</th>
          <th>Due</th>
          <th>Less</th>
          <th>End Date</th>
        </tr>
      </thead>
      <tbody>
        ${bodyRows}
        <tr class="total-row">
          <td colspan="4" class="text-center"><strong>Total (${rows.length} Orders)</strong></td>
          ${totalsCols}
          <td class="text-center"><strong>৳${overallTotal.toLocaleString()}</strong></td>
          <td class="text-center"><strong>৳${overallPaid.toLocaleString()}</strong></td>
          <td class="text-center"><strong>৳${overallDue.toLocaleString()}</strong></td>
          <td class="text-center"><strong>৳${overallLess.toLocaleString()}</strong></td>
          <td></td>
        </tr>
      </tbody>
    </table>

    <div class="summary-section">
      <h3>Summary</h3>
      <p><strong>Total Orders:</strong> ${rows.length}</p>
      <p><strong>Total Collection:</strong> ৳${overallTotal.toLocaleString()}</p>
    </div>

    <div style="margin-top:40px;text-align:right;">
      <div style="display:inline-block;width:220px;border-top:1px dotted #000;padding-top:6px;">Signature</div>
    </div>
`;
};

const printCollectionReport = (superGroups, orders, reportTitle) => {
  const sgs = Array.isArray(superGroups) ? superGroups : [];
  const rows = Array.isArray(orders) ? orders : [];

  const collectionDate = rows.length > 0 && rows[0].createdAt
    ? moment(rows[0].createdAt).format('DD-MMMM-YYYY')
    : moment().format('DD-MMMM-YYYY');
  const printTitle = `${reportTitle || 'Daily Collection Report'} - ${collectionDate}`;
  const printContent = generatePrintableContent(sgs, rows, reportTitle) || '<div style="padding:20px;">No data to print</div>';

  const fullHtml = `
    <html>
      <head>
        <title>${printTitle}</title>
        <style>
          ${defineCss()}
        </style>
      </head>
      <body>
        ${printContent}
      </body>
    </html>
  `;

  openPrintPreview(fullHtml, printTitle);
};

export default printCollectionReport;
